<template>
	<div>
		<admin-crop-grid
			:title="title"
			:rows="data"
			:cols="cols"
			:title-is-bold="false"
		/>
	</div>
</template>
<script>
export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
	},
	data: function () {
		console.log("DATA");
		return {
			cols: [
				{
					id: "id",
					name: "ID",
					render: (id) => "#" + id,
				},
				{
					id: "company_name",
					name: this.__("Company name"),
				},
			],
		};
	},
	computed: {
		title() {
			return this.__("The following users will receive the bid");
		},
	},
};
</script>
